import template from './index.html'
import controller from './controller'

export const vsName = 'meallogMainGrid'
export const vsNgType = 'directive'

MealLogMainGrid.$inject = []
export function MealLogMainGrid() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {},
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true
  }
}